import { useState } from 'react';
import Button from '../components/Button';

interface LoginProps {
  onLogin: (email: string, password: string) => Promise<boolean>;
  onRegister: (companyName: string, email: string, password: string, name: string) => Promise<boolean>;
  error: string | null;
  loading: boolean;
}

export default function Login({ onLogin, onRegister, error, loading }: LoginProps) {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isRegister) {
      await onRegister(companyName, email, password, name);
    } else {
      await onLogin(email, password);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-primary text-white text-2xl font-bold mb-4">
            適
          </div>
          <h1 className="text-2xl font-bold text-text-main">テキザイテキショ</h1>
          <p className="text-sm text-text-sub mt-1">AIが導く、適材適所の最適解</p>
        </div>

        <div className="bg-card border border-border rounded-xl p-6">
          <div className="flex mb-6 border-b border-border">
            <button
              onClick={() => setIsRegister(false)}
              className={`flex-1 pb-3 text-sm font-semibold transition-colors ${
                !isRegister
                  ? 'text-primary border-b-2 border-primary'
                  : 'text-text-muted hover:text-text-sub'
              }`}
            >
              ログイン
            </button>
            <button
              onClick={() => setIsRegister(true)}
              className={`flex-1 pb-3 text-sm font-semibold transition-colors ${
                isRegister
                  ? 'text-primary border-b-2 border-primary'
                  : 'text-text-muted hover:text-text-sub'
              }`}
            >
              新規登録
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {isRegister && (
              <>
                <div>
                  <label className="block text-xs text-text-sub mb-1.5">企業名</label>
                  <input
                    type="text"
                    value={companyName}
                    onChange={e => setCompanyName(e.target.value)}
                    placeholder="株式会社サンプル"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-border bg-surface text-text-main text-sm outline-none focus:border-primary transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs text-text-sub mb-1.5">管理者名</label>
                  <input
                    type="text"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    placeholder="山田 太郎"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-border bg-surface text-text-main text-sm outline-none focus:border-primary transition-colors"
                  />
                </div>
              </>
            )}

            <div>
              <label className="block text-xs text-text-sub mb-1.5">メールアドレス</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="admin@example.com"
                required
                className="w-full px-4 py-2.5 rounded-lg border border-border bg-surface text-text-main text-sm outline-none focus:border-primary transition-colors"
              />
            </div>

            <div>
              <label className="block text-xs text-text-sub mb-1.5">パスワード</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                minLength={8}
                className="w-full px-4 py-2.5 rounded-lg border border-border bg-surface text-text-main text-sm outline-none focus:border-primary transition-colors"
              />
            </div>

            {error && (
              <div className="text-xs text-accent bg-caution-bg rounded-lg p-3">{error}</div>
            )}

            <Button primary type="submit" disabled={loading} className="w-full">
              {loading ? '処理中...' : isRegister ? '企業登録' : 'ログイン'}
            </Button>
          </form>
        </div>

        <div className="text-center mt-6 text-[10px] text-text-muted leading-relaxed">
          MBTIはMyers & Briggs Foundation, Inc.の登録商標です。<br />
          本サービスは公式MBTI製品ではありません。
        </div>
      </div>
    </div>
  );
}
